import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  paymentPlanConsentId: string
}

type AcceptPaymentPlanConsentProps = {
  onSuccess?: () => void
}

export function useAcceptPaymentPlanConsent({
  onSuccess = undefined,
}: AcceptPaymentPlanConsentProps) {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, MutationFnParams>({
    mutationFn: async ({ paymentPlanConsentId }) => {
      await fetcher(
        `/Transaction/PaymentPlanConsent/${paymentPlanConsentId}/Accept`,
        {
          method: "POST",
        },
        {
          useAccessToken: true,
        }
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["paymentPlanConsent"] })
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error) => {
      console.log("error?", error)
    },
  })
}
